var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntrnautsAiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 559.45 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        opacity: .7;\n      }\n\n      .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-5, .cls-6 {\n        font-family: Arial-BoldMT, Arial;\n        font-size: 70px;\n        font-weight: 700;\n      }\n\n      .cls-7 {\n        font-family: ArialMT, Arial;\n        font-size: 20px;\n      }\n\n      .cls-7, .cls-8 {\n        fill: #5a5b5b;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-6, .cls-23 {\n        fill: #0a2342;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 559.45,
    height: 190
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 559.45,
    height: 190
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,75C15,80,0,105,0,130c0,35,25,60,60,60h130c30,0,55-25,55-55s-25-55-55-55c-10-35-40-65-80-65-35,0-65,25-70,60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -25.62,
    y1: -19.53,
    x2: -24.62,
    y2: -19.53,
    gradientTransform: "translate(1493.58 7915.99) rotate(35.54) scale(301.08 284.81) skewX(-17.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a2342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e3f66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 559.45,
    height: 190
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.2,
    y: 49.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.2,
    y: 49.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.2,
    y: 89.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.2,
    y: 89.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.2,
    y: 89.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.2,
    y: 89.4,
    width: 31.6,
    height: 41.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 260,
    y: 79.95,
    width: 299.45,
    height: 86.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 260,
    y: 79.95,
    width: 85.52,
    height: 86.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 260,
    y: 152.84,
    width: 265.73,
    height: 23.66
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_1",
    "data-name": "Artwork 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "-122.5 102.5 122.5 277.5 367.5 102.5 122.5 -72.5 -122.5 102.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M150,42c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M120,82c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M180,82c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M90,122c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M150,122c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M210,122c4.42,0,8,3.58,8,8s-3.58,8-8,8-8-3.58-8-8,3.58-8,8-8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 150,
    y1: 50,
    x2: 120,
    y2: 90
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 150,
    y1: 50,
    x2: 180,
    y2: 90
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120,
    y1: 90,
    x2: 90,
    y2: 130
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120,
    y1: 90,
    x2: 150,
    y2: 130
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180,
    y1: 90,
    x2: 150,
    y2: 130
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180,
    y1: 90,
    x2: 210,
    y2: 130
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 150,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 130,
    y: 30,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 170,
    y: 30,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(260 140)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "int")))), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(345.52 140)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "rnauts")))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(260 170)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "navigating intelligent solutions"))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrnautsAiLogo);
export default __webpack_public_path__ + "static/media/intrnauts-ai-logo.3e3cb8d3f8f3682790dcee692b632897.svg";
export { ForwardRef as ReactComponent };